<template>
  <div id="repayment-schedule-tab">
    <div class="float-right">
      <action-button />
    </div>

    <table>
      <thead>
        <tr>
          <th>{{ $t('DAYS') }}</th>
          <th>{{ $t('CONTRACT_CREATED_DATE') }}</th>
          <th>{{ $t('PAID_DATE') }}</th>
          <th>{{ $t('PRICINPAL_DUE') }}</th>
          <th>{{ $t('BALANCE_OF_LOAN') }}</th>
          <th>{{ $t('INTEREST_AMOUNT') }}</th>
          <th>{{ $t('FEE') }}</th>
          <th>{{ $t('OVERDUE_FEE') }}</th>
          <th>{{ $t('TOTAL') }}</th>
          <th>{{ $t('PAID') }}</th>
          <th>{{ $t('IN_ADVANCE') }}</th>
          <th>{{ $t('OUTSTANDING_AMOUNT') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="key" v-for="(period, key) in repaymentScheduleData.periods">
          <td>{{ period.daysInPeriod }}</td>
          <td>{{ formateDate(period.dueDate) }}</td>
          <td>{{ formateDate(period.obligationsMetOnDate) }}</td>
          <td>{{ addCommas(period.principalOutstanding) }}</td>
          <td>{{ addCommas(period.principalLoanBalanceOutstanding) }}</td>
          <td>{{ addCommas(period.interestOutstanding) }}</td>
          <td>{{ addCommas(period.feeChargesOutstanding) }}</td>
          <td></td>
          <td>{{ addCommas(period.totalDueForPeriod) }}</td>
          <td>{{ addCommas(period.totalPaidForPeriod) }}</td>
          <td>{{ addCommas(period.totalPaidInAdvanceForPeriod) }}</td>
          <td>{{ addCommas(period.totalOutstandingForPeriod) }}</td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t('TOTAL') }}</td>
          <td></td>
          <td>{{ addCommas(repaymentScheduleData.totalPrincipalExpected) }}</td>
          <td></td>
          <td>{{ addCommas(repaymentScheduleData.totalInterestCharged) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalFeeChargesCharged) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalPenaltyChargesCharged) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalRepaymentExpected) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalRepayment) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalAdvancePayment) }}</td>
          <td>{{ addCommas(repaymentScheduleData.totalOutstanding) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import { computed, onMounted } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { faHourglass, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { addCommas } from '@/helpers';
import { CALL_STATUSES } from '@/consts';

import ActionButton from '../../ActionButton';

const { useState, useActions } = createNamespacedHelpers('contractDetail');
const { useState: usePhoneState } = createNamespacedHelpers('phone');

export default {
  name: 'RepaymentScheduleTab',
  components: {
    ActionButton,
  },
  setup(_, { root }) {
    const { repaymentSchedule, detail } = useState(['repaymentSchedule', 'detail']);
    const { status } = usePhoneState(['status']);

    const getRepaymentScheduleFunction = (repaymentScheduleState) => {
      if (repaymentScheduleState === null) {
        return () => '';
      }
      return (name) => repaymentScheduleState[name];
    };

    const repaymentScheduleData = computed(() => {
      const get = getRepaymentScheduleFunction(repaymentSchedule.value);

      return {
        periods: get('periods'),
        totalOutstanding: get('totalOutstanding'),
        totalPaidLate: get('totalPaidLate'),
        totalAdvancePayment: get('totalAdvancePayment'),
        totalRepayment: get('totalRepayment'),
        totalRepaymentExpected: get('totalRepaymentExpected'),
        totalPenaltyChargesCharged: get('totalPenaltyChargesCharged'),
        totalFeeChargesCharged: get('totalFeeChargesCharged'),
        totalInterestCharged: get('totalInterestCharged'),
        totalPrincipalExpected: get('totalPrincipalExpected'),
      };
    });

    const { getRepaymentScheduleByMifosId } = useActions(['getRepaymentScheduleByMifosId']);

    const { id: contractMifosId } = root.$route.params;

    onMounted(() => {
      getRepaymentScheduleByMifosId(contractMifosId);
    });

    const formateDate = (date) => {
      const momentDate = moment(date, 'YYYY-MM-DD');
      if (momentDate.isValid()) {
        return momentDate.format('DD/MM/YYYY');
      }
      return '';
    };

    // TODO: Refactor Contract Renew and Repay v2
    const navigateRenew = () => {
      let target = '_self';
      if (status.value === CALL_STATUSES.TALKING) {
        target = '_blank';
      }

      window.open(`${process.env.VUE_APP_SITE_URL}/contracts/${detail.value.id}/extension-contract`, target);
    };

    const navigateRepay = () => {
      let target = '_self';
      if (status.value === CALL_STATUSES.TALKING) {
        target = '_blank';
      }

      window.open(`${process.env.VUE_APP_SITE_URL}/contracts/${detail.value.id}/contract-repayment`, target);
    };

    return {
      repaymentScheduleData,
      addCommas,
      navigateRenew,
      navigateRepay,
      faHourglass,
      faCheckCircle,
      formateDate,
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#repayment-schedule-tab {
  padding-top: 20px;
  border-radius: 3px;

  table {
    margin-top: 60px;
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;

    thead {
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;

      tr {

        th {
          background-color: $brightMaroon;
          color: $white;
          padding: 15px 10px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;

          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        background-color: $babyPowder;
        transition: all .2s ease-in-out;

        &:hover {
          background-color: $ghostWhite;
        }

        &:last-child {
          font-weight: bold;
          text-transform: uppercase;
        }

        td {
          padding: 15px 5px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }

          &.child {
            padding-left: 25px;
          }
        }
      }
    }
  }
}
</style>
